import React from 'react'
import { NotClaimedYetIcon, DefaultWineryIcon } from '../../../assets';
import { NamedLink } from '../../../components';
import css from './WineryNotClaimedYetMessage.module.css';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import wineryDefaultImage from './image.png';

function WineryNotClaimedYetMessage({winery}) {
  return (
    <div className={css.container}>
      <div className={css.wrapper}>
        <div className={css.contentWrapper}>
          <div className={css.iconWrapper}>
            <DefaultWineryIcon style={{width: '80%', height: '75%'}} />
          </div>
          <div>
            <h1 className={css.contentTitle}>Are you the owner or manager of this winery?
              <NamedLink name="ClaimPage" params={{ id: winery._id}}>
                {" "} Claim your page to:
              </NamedLink>
            </h1>
            <ul className={css.listWrapper}>
              <li className={css.listItem}> <IoMdCheckmarkCircleOutline /> <span>Update and add info about your winery (description, slogan, photos, hours, etc.)</span></li>
              <li className={css.listItem}> <IoMdCheckmarkCircleOutline /> <span>Let visitors know if reservations are required, or if your venue is kid and/or dog friendly</span></li>
              <li className={css.listItem}> <IoMdCheckmarkCircleOutline /> <span>Highlight key members of your team</span></li>
              <li className={css.listItem}> <IoMdCheckmarkCircleOutline /> <span>Add a plug for your Wine Club</span></li>
              <li className={css.listItem}> <IoMdCheckmarkCircleOutline /> <span>List your wines to drive online sales</span></li>
              <li className={css.listItem}> <IoMdCheckmarkCircleOutline /> <span>And much more!</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WineryNotClaimedYetMessage;
